
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Register',
  data() {
    return {
      schema: {
        name: 'required|min:4|max:70|alpha_spaces',
        email: 'required|min:4|max:70|email',
        password: 'required|min:6|max:50',
        password_confirmation: 'password_mismatch:@password',
      },
      regist: {
        in_submission: false,
        show_alert: false,
        alert_variant: 'alert-primary',
        alert_message: 'Please wait! Your account is being created.',
      },
    };
  },
  methods: {
    async register(values: object) {
      this.regist.in_submission = true;
      this.regist.show_alert = true;
      this.regist.alert_variant = 'alert-primary';
      this.regist.alert_message = 'Please wait! Your account is being created.';

      try {
        await this.$store.dispatch('register', values);
      } catch (error: any) {
        this.regist.in_submission = false;
        this.regist.alert_variant = 'alert-danger';
        this.regist.alert_message = error.message;
        return;
      }

      this.regist.alert_variant = 'alert-success';
      this.regist.alert_message = 'Success! Your account has been created';

      window.location.reload();
    },
  },
});
